import React, {useEffect} from "react";
import YouTube from '@u-wave/react-youtube';
import {useTypedSelector} from "../../hooks/useTypeSelector";

var debounce = require('lodash/debounce');

interface HeroVideoProps {
    siteOrigin: string;
}

const HeroVideo = (props:HeroVideoProps) => {


    const CalculateVideoDimensions = () => {
        let width = window.innerWidth + 50;

        //16:9 calculation
        let height = 0.5625 * width;

        let dimensionArray = {};
        dimensionArray["width"] = width;
        dimensionArray["height"] = height;

        return dimensionArray;
    }

    const {  productData } = useTypedSelector((state) => state.product);

    const [dimensions, setDimensions] = React.useState({
        height: 0,
        width: 0
    })
    
    useEffect(() => {
        let videoDims = CalculateVideoDimensions();

        setDimensions({
            height: videoDims["height"],
            width: videoDims["width"]
        })
    }, [])
    
    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            let videoDims = CalculateVideoDimensions();
            
            setDimensions({
                height: videoDims["height"],
                width: videoDims["width"]
            })
        }, 1000)
        
        window.addEventListener('resize', debouncedHandleResize)
        
        return () => {
            window.removeEventListener('resize', debouncedHandleResize)
        }
    }, [productData])

    if(productData == undefined ||
        productData.Videos == undefined ||
        productData.Videos.length == 0) {

        return null;
    }

    const heroVideo = productData.Videos.find((video) => video.FeatureVideo == true);
    
    if(heroVideo == undefined || heroVideo.VideoUrl == null) {
        return null;
    }
    
    return (
        <div className="hero-video">
            <YouTube
                video={heroVideo.VideoUrl}
                autoplay
                muted
                modestBranding
                showRelatedVideos={false}
                width={dimensions.width}
                height={dimensions.height}
                onEnd={(event)=>event.target.playVideo()}
            />
 
        </div>
    )
}

export default HeroVideo;